import NetworkFormBusinessSections from 'src/containers/comunidad-network/form/NetworkFormBusinessSections';
import NetworkFormJobPostings from 'src/containers/comunidad-network/form/NetworkFormJobPostings';
import NetworkFormMedia from 'src/containers/comunidad-network/form/NetworkFormMedia';

const NetworkCompanyFormBody = ({
  inputs,
  errorInputs,
  sending,
  lookingUp = false,
  handleInputs,
  selectHandle,
  selectOnBlur = true,
  media,
  owner,
  actions,
  onJobPostingsChange,
}) => (
  <>
    {owner}
    <NetworkFormBusinessSections
      inputs={inputs}
      errorInputs={errorInputs}
      handleInputs={handleInputs}
      selectHandle={selectHandle}
      selectOnBlur={selectOnBlur}
    />
    <NetworkFormMedia
      disabled={sending || lookingUp}
      logoPreview={media.logoPreview}
      catalogItems={media.catalogItems}
      onLogoSelected={media.onLogoSelected}
      onLogoClear={media.onLogoClear}
      onCatalogSelected={media.onCatalogSelected}
      onCatalogRemove={media.onCatalogRemove}
    />
    <NetworkFormJobPostings
      jobPostings={inputs.jobPostings}
      errorInputs={errorInputs}
      disabled={sending || lookingUp}
      onChange={onJobPostingsChange}
    />
    {actions}
  </>
);

export default NetworkCompanyFormBody;
